export const PLACEMENT = 'job-board-page'
export const ALERT_MESSAGE =
    ' You cannot edit job boards starting within the next hour and can only edit future seven-day job boards from today.'

export const JOB_BOARD_DAY_STATUS = {
    noJobBoard: null,
    completed: 'completed',
    inProgress: 'in_progress',
    notStarted: 'not_started',
    cancelled: 'cancelled',
}
export const REGION = {
    US: 'US',
    INDIA: 'India',
}

export const ASSIGN_MP = 'assign_mp'
export const TIME_FORMAT = 'hh:mm A'
export const CALENDER_WEEKDAY_FORMAT = 'ddd'
export const CALENDER_DATE_FORMAT = 'D'
export const CALENDER_HEADER_DATE_FORMAT = 'MMM DD, YYYY'
export const US_TIMEZONE = 'America/Los_Angeles'
export const INDIA_TIMEZONE = 'Asia/Kolkata'
export const MODAL_DATE_FORMAT = 'MM/DD/YYYY'
